import { Clear, Edit, MapRounded } from '@mui/icons-material';
import { Box, IconButton, TextField } from '@mui/material';
import React, { useState } from 'react';
import { Address } from '../../../types/Address';
import ConfirmationModal from '../../ConfirmationModal';
import EventAddressModal from './EventAddressModal';
import _ from 'lodash';

interface EventAddressProps {
  address: Address | null;
  accountAddresses: Address[];
  onAddressChange: (address?: Address) => void;
}

const EventAddress: React.FC<EventAddressProps> = ({ address, accountAddresses, onAddressChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showConfirmClear, setShowConfirmClear] = useState(false);

  const handleAddressSave = (newAddress: Address) => {
    onAddressChange(newAddress);
    setIsModalOpen(false);
  };

  const handleOpenModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  const handleClearAddress = () => {
    onAddressChange(undefined);
    setShowConfirmClear(false);
  };

  const formatAddress = (address: Address | null) => {
    if (!address) return '';
    return _.filter([address.address_1, address.city, address.division, address.country, address.postal_code]).join(', ');
  };

  const endAdornment = (
    address &&
    <>
      <IconButton onClick={handleOpenModal} size="small">
        <Edit />
      </IconButton>
      <IconButton
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.formatted_address || '')}`}
        target="_blank"
        size="small"
        onClick={(e) => e.stopPropagation()}
      >
        <MapRounded />
      </IconButton>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          setShowConfirmClear(true);
        }}
        size="small"
      >
        <Clear />
      </IconButton>
    </>
  );

  return (
    <Box sx={{ width: '100%', gridColumn: { sm: 'span 2' }, pt: { xs: 2, sm: 0 } }}>
      <TextField
        label="Event Address"
        fullWidth
        variant="outlined"
        value={address?.formatted_address || formatAddress(address)}
        onClick={handleOpenModal}
        placeholder="Add Address"
        slotProps={{
          input: {
            endAdornment,
            readOnly: true,
          }
        }}
      />

      <EventAddressModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onSave={handleAddressSave}
        addressToEdit={address}
        accountAddresses={accountAddresses}
      />

      <ConfirmationModal
        text="Are you sure you want to clear this address?"
        isOpen={showConfirmClear}
        onCancel={() => setShowConfirmClear(false)}
        onConfirm={handleClearAddress}
      />
    </Box>
  );
};

export default EventAddress;
